"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useItinInfo = void 0;
const zustand_1 = require("zustand");
const middleware_1 = require("zustand/middleware");
exports.useItinInfo = (0, zustand_1.create)()((0, middleware_1.persist)((0, middleware_1.devtools)((set) => {
    return {
        timezone: undefined,
        setTimezone: (timezone) => {
            set({ timezone }, false, 'setItinTimezone');
        },
    };
}), {
    name: 'itinInfoStore',
}));
